// extracted by mini-css-extract-plugin
export default {"PageLoader":"PageLoader__PageLoader___GWLno","loader":"PageLoader__loader___IQbEc"};